// ** Icons Import
import { Children } from 'react'
import { Home, Circle, FilePlus, CheckSquare, Monitor, Search } from 'react-feather'
// import { FaBeer } from "react-icons/fa";

export default [
  {
    header: 'MFG Menu'
  },
  {
    id: '612',
    title: 'M.75 Request',
    icon: <FilePlus size={12} />,
    navLink: '/mfg-m75-request'
  },
  {
    id: '613',
    title: 'M.75 Approval',
    icon: <CheckSquare size={12} />,
    navLink: '/mfg-m75-approval'
  },
  {
    id: '614',
    title: 'M.75 History',
    icon: <Search size={12} />,
    navLink: '/mfg-m75-history'
  },
  {
    id: '615',
    title: 'M.75 History (Subordinate)',
    icon: <Monitor size={12} />,
    navLink: '/mfg-m75-subordinate'
  }
  // {
  //   id: '548',
  //   title: 'M.75 Request',
  //   icon: <FilePlus size={12} />,
  //   navLink: '/mfg-m75-request',
  // },
  // {
  //   id: '549',
  //   title: 'M.75 Approval',
  //   icon: <CheckSquare size={12} />,
  //   navLink: '/mfg-m75-approval',
  // },
  // {
  //   id: '550',
  //   title: 'M.75 History',
  //   icon: <Search size={12} />,
  //   navLink: '/mfg-m75-history',
  // },
  // {
  //   id: '551',
  //   title: 'M.75 History (Subordinate)',
  //   icon: <Monitor size={12} />,
  //   navLink: '/mfg-m75-subordinate',
  // },
]
